import styled from '@emotion/styled';

export const MapViewport = styled.div`
  position: relative;
  pointer-events: none !important;
`;
